import { useMemo } from "react";

import { FeaturesFlagsQuery } from "@/graphql/generated/graphql";
import { FeaturesFlags } from "@/graphql/queries/FeaturesFlags";
import { useGraphQuery } from "@dashboard/library";
import {
  FeaturesFlagsData,
  GetFeaturesFlagsType,
} from "./useGetFeaturesFlags.decl";
/**
 * Hook providing feature flags.
 * @returns an object holding application feature flags
 */
export function useGetFeaturesFlags(): GetFeaturesFlagsType {
  const { data, loading } = useGraphQuery<FeaturesFlagsQuery>(FeaturesFlags, {
    throwError: true,
  });

  const featureFlags = useMemo(() => {
    if (!data) {
      return undefined;
    }

    const {
      featureFlags: { __typename, ...rest },
    } = data;

    return Object.entries(rest).reduce(
      (acc, [ffKey, ffValue]) => ({
        ...acc,
        [ffKey]: Boolean(ffValue),
      }),
      {} as FeaturesFlagsData
    );
  }, [data]);

  return useMemo(() => {
    return {
      loading,
      ...(featureFlags ?? {}),
    };
  }, [featureFlags, loading]);
}
